<template>
	<div class="flex flex-wrap gap-3 relative w-full">
		<div class="flex gap-2">
			<Checkbox
				v-model="checked"
				:binary="true"
				:name="props.name"
				:input-id="props.label"
				class="tv__checkbox"
				@change="updateValue && handleChange"
			/>
			<div class="flex flex-column gap-1">
				<label :for="props.label" class="tv__checkbox-label inline-block">
					{{ props.label }}
				</label>
				<span class="input-message-content">
					<small
						v-if="props.customErrorMessage || errorMessage"
						class="tv__input-error-message flex"
					>
						<i class="tv__input-icon tv__input-icon-error" />
						{{ props.customErrorMessage || errorMessage }}
					</small>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup>
import { defineProps, defineEmits, toRef, watch } from 'vue'
import Checkbox from 'primevue/checkbox'
import { useField } from 'vee-validate'

const props = defineProps({
	label: String,
	customErrorMessage: String,
	error: Boolean,
	name: String,
	modelValue: String,
})

const {
	value: checked,
	errorMessage,
	handleChange,
} = useField(toRef(props, 'name'), undefined, {
	initialValue: props.modelValue,
})
// Defining emitted events with defineEmits
const emit = defineEmits(['update:modelValue'])

// Function to handle checkbox change
const updateValue = (newValue) => {
	emit('update:modelValue', newValue)
}

watch(
	() => props.modelValue,
	(newValue) => {
		if (newValue !== undefined) {
			checked.value = newValue
		}
	},
)

watch(checked, (newValue) => {
	if (newValue !== undefined) {
		updateValue(newValue)
	}
})
</script>
